import * as Sentry from "@sentry/react";

export function AppErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ eventId, resetError }) => (
        <div className="flex h-screen items-center justify-center bg-background">
          <div className="max-w-md w-full text-center space-y-4 p-8">
            <h2 className="text-xl font-semibold text-foreground">
              Something went wrong
            </h2>
            <p className="text-sm text-muted-foreground">
              Our team has been notified. If this keeps happening, contact
              support with this reference code:
            </p>
            <p className="font-mono text-xs bg-muted px-3 py-2 rounded border border-border break-all">
              {eventId}
            </p>
            <button
              onClick={resetError}
              className="text-sm text-primary underline underline-offset-4"
            >
              Try again
            </button>
          </div>
        </div>
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
